import React from "react"
import SelectMenu from "../select-menu"
import type { SelectMenuProps, SelectSeparator } from "../select-menu"
import { fontOptions } from "./font-options"
import type { FontOption } from "./font-options"

export { fontOptions }
export type { FontOption }

export type FontSelectProps = Omit<SelectMenuProps, "options"> & {
  /** Font options to display (defaults to built-in font list) */
  options?: (FontOption | SelectSeparator)[]
}

/**
 * A font picker built on SelectMenu, pre-populated with a curated list of
 * serif, sans-serif, and handwritten fonts. Pass custom `options` to override
 * the defaults.
 */
function FontSelect(props: FontSelectProps) {
  return <SelectMenu options={fontOptions} {...props} />
}

export { FontSelect }
export default FontSelect
